import Vue from 'vue'
export const erpDefs = Vue.observable({
    loaded: false,
    invoices: [],
    financialBlock: false,
    block: false,
    blockMessage: null
})
